/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ofType } from 'redux-observable';
import { of, timer, combineLatest } from 'rxjs';
import { withLatestFrom, pluck, mergeMap, debounce } from 'rxjs/operators';
import { filterAvailabilityByFilterText } from '../../utils/availabilityReducerUtil';
import {
    FILTER_AVAILABILITIES_BY_INPUT_COMPLETE,
    SET_FILTER_INPUT,
    FILTER_AVAILABILITIES_BY_SEARCH_COMPLETE,
} from '../../constants';

/**
 *
 * @param {Observable} action$ - a stream of actions
 * @param {Observable} state$ - a stream of redux store states
 */
export const filterAvailabilityByInputEpic = (action$, state$) =>
    action$.pipe(
        ofType(
            FILTER_AVAILABILITIES_BY_SEARCH_COMPLETE, // when new campsite monthly availability data are fetched, combined, and filtered by search campsites
            SET_FILTER_INPUT // when filter input changes
        ),
        debounce((stream) => {
            /* if incoming action is SET_FILTER_INPUT, debounce by 0.5 sec for better user experience, since we don't
        need to filter a massive data set on each keyboard input. Else, immediately proceed with filter */
            return stream.type === SET_FILTER_INPUT ? timer(300) : timer(0);
        }),
        withLatestFrom(
            combineLatest(
                state$.pipe(pluck('availabilityGrid')),
                state$.pipe(pluck('availableCampsites'), pluck('campsitesByKeys'))
            )
        ),
        mergeMap((stream) => {
            const states = stream[1];
            const [availabilityGrid, campsites] = states;
            const { filterText, filteredAvailabilitiesBySearch } = availabilityGrid;

            // filter the sorted availabilities by filter text
            const filteredAvailabilitiesByText = filterAvailabilityByFilterText(
                campsites,
                filteredAvailabilitiesBySearch,
                filterText
            );
            return of({
                type: FILTER_AVAILABILITIES_BY_INPUT_COMPLETE,
                payload: filteredAvailabilitiesByText,
            });
        })
    );
